export default "__VITE_ASSET__nF4XegMg__"